import React, { FC, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
// mui components
import { Box, Grid } from '@mui/material';
// components
import DialogModal from 'components/modal/dialog-modal';
// helpers
import { fileModalContentHelper } from './helpers';
// api
import {
  useGetShowCabinetFileURLQuery,
  useGetShowPublicCabinetFileURLQuery,
} from 'redux/api/file-cabinet';
// icons
import CloseIcon from '@mui/icons-material/Close';
// styles
import { styles } from './styles';

type Props = {
  open: boolean;
  handleClose: () => void;
  mimeType: string;
  id: string | number;
  accessKey?: string | number;
  publicFolders: boolean;
  projectId: string | number;
};

const FilesViewModal: FC<Props> = ({
  open,
  mimeType,
  id,
  accessKey,
  publicFolders,
  projectId,
  handleClose,
}) => {
  const location = useLocation();

  const { data: privateData } = useGetShowCabinetFileURLQuery(
    { fileId: id, projectId: projectId },
    { skip: location.pathname.includes('public-file-cabinet') }
  );
  const { data: publicFileData } = useGetShowPublicCabinetFileURLQuery(
    { accessKey: accessKey },
    { skip: !location.pathname.includes('public-file-cabinet') }
  );

  const getFileURL = useCallback(() => {
    if (publicFolders) {
      return publicFileData?.url;
    }

    return privateData?.url;
  }, [privateData, publicFileData, publicFolders]);

  const content = fileModalContentHelper(mimeType, getFileURL());

  return (
    <DialogModal open={open} handleClose={handleClose} maxWidth="900px" withoutPadding={true}>
      <Grid sx={styles.modalHeader}>
        <CloseIcon sx={styles.icon} onClick={handleClose} />
      </Grid>

      <Box sx={styles.wrapper}>{content}</Box>
    </DialogModal>
  );
};

export default FilesViewModal;
